module.exports = __webpack_public_path__ + "img/attack_electrictornardo.09106d36.png";